import { AI_SETTING_KEYS, getDefaultModel, normalizeModel, normalizeProvider } from './modelConfig.js'
import { storage } from './storage.js'

const keyForProvider = (provider) => (
  normalizeProvider(provider) === 'gemini' ? AI_SETTING_KEYS.geminiKey : AI_SETTING_KEYS.deepseekKey
)

export const loadAiSettings = () => {
  const legacy = storage.json(AI_SETTING_KEYS.legacy, {})
  const provider = normalizeProvider(storage.get(AI_SETTING_KEYS.provider, legacy.provider || 'deepseek'))
  const model = storage.get(
    `${AI_SETTING_KEYS.model}.${provider}`,
    storage.get(AI_SETTING_KEYS.model, legacy[`${provider}Model`] || getDefaultModel(provider)),
  )
  return {
    provider,
    model: normalizeModel(provider, model),
    apiKey: storage.get(keyForProvider(provider), legacy[`${provider}Key`] || ''),
  }
}

export const loadProviderSettings = (provider) => {
  const normalized = normalizeProvider(provider)
  const legacy = storage.json(AI_SETTING_KEYS.legacy, {})
  const model = storage.get(
    `${AI_SETTING_KEYS.model}.${normalized}`,
    legacy[`${normalized}Model`] || getDefaultModel(normalized),
  )
  return {
    provider: normalized,
    model: normalizeModel(normalized, model),
    apiKey: storage.get(keyForProvider(normalized), legacy[`${normalized}Key`] || ''),
  }
}

export const saveAiSettings = ({ provider, model, apiKey }) => {
  const normalized = normalizeProvider(provider)
  const safeModel = normalizeModel(normalized, model)
  storage.set(AI_SETTING_KEYS.provider, normalized)
  storage.set(AI_SETTING_KEYS.model, safeModel)
  storage.set(`${AI_SETTING_KEYS.model}.${normalized}`, safeModel)
  storage.set(keyForProvider(normalized), apiKey.trim())

  const deepseek = loadProviderSettings('deepseek')
  const gemini = loadProviderSettings('gemini')
  storage.set(AI_SETTING_KEYS.legacy, JSON.stringify({
    provider: normalized,
    deepseekKey: deepseek.apiKey,
    deepseekModel: deepseek.model,
    geminiKey: gemini.apiKey,
    geminiModel: gemini.model,
  }))
  return { provider: normalized, model: safeModel, apiKey: apiKey.trim() }
}

export const clearAiKeys = () => {
  storage.remove(AI_SETTING_KEYS.deepseekKey)
  storage.remove(AI_SETTING_KEYS.geminiKey)
  storage.remove(AI_SETTING_KEYS.legacy)
}
